import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { SYSTEM_ROLE_ID } from '@fry/lib/roles/roles.system';
import { BackendObjectRef } from '../lib/backend-integration.service';
import { SelectControlGroup, WorkflowEditorStore } from '../lib/workflow-editor.store';

// Type this form returns as result
export interface WorkflowCreateFormResult {
  name: string;
  selectedRoles: string[];
  state: string;
}

// Controls should have same names as the Result to ensure correct form.value
type WorkflowCreateFormControls = {[K in keyof WorkflowCreateFormResult]: AbstractControl};

@Component({
    selector: 'eas-workflow-create-form',
    templateUrl: './workflow-create-form.component.html',
    styleUrls: ['./workflow-create-form.component.css'],
    standalone: false
})
export class WorkflowCreateFormComponent implements OnChanges {

  @Input() availableRoles: BackendObjectRef[] = [];

  public rolesSelectData: SelectControlGroup<BackendObjectRef>[] = [];

  // When user finishes continues we emit the result
  @Output() didContinue = new EventEmitter<WorkflowCreateFormResult>();

  public form: FormGroup;

  constructor(formBuilder: FormBuilder) {
    const controls: WorkflowCreateFormControls = {
      name: formBuilder.control('', Validators.required),
      selectedRoles: formBuilder.control([SYSTEM_ROLE_ID.TIMELINE_OWNER], Validators.required),
      state: formBuilder.control('DRAFT', Validators.required)
    };
    this.form = formBuilder.group(controls);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['availableRoles']) {
      this.rolesSelectData = WorkflowEditorStore.createRolesSelectData(this.availableRoles, []);
    }
  }

  //
  // Actions
  //

  public onContinue(): void {
    if (this.form.invalid) { return; }
    this.didContinue.emit(this.form.value);
  }
}
